import React from 'react';
import gpt3Logo from '../../assets/logo.svg';
import './footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-heading">
      <h1 className="gradient__text">Do you want to step in to the future before others</h1>
    </div>

    <div className="gpt3__footer-btn">
      <p>Request Early Access</p>
    </div>

    <div className="gpt3__footer-links">
      <div className="gpt3__footer-links_logo">
        <img src={gpt3Logo} alt="gpt3_logo" />
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Links</h4>
        <p>Overons</p>
        <p>Social Media</p>
        <p>Counters</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Company</h4>
        <p>Terms & Conditions </p>
        <p>Privacy Policy</p>
        <p>Contact</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Get in touch</h4>
        <a href="https://spur-tech.github.io/SPUR-TECH-Designs/" target="_blank" rel="noreferrer">
        <p>~ <i>SPUR </i> -<b>TECH</b> <i>Web Designs</i> ~ </p></a>
        <p>074653782111</p>
        <p>info@payme.com</p>
      </div>
    </div>

    <div className="gpt3__footer-copyright">
      <p>&copy; Copyright ~ <i>SPUR </i> -<b>TECH</b> <i>Web Designs</i> ~ @ 2023</p>
    </div>
  </div>
);

export default Footer;